<template>
  <div class="d-flex flex-column ga-4">
    <h2 class="fs-24">
      {{ $bct('Applications') }}
    </h2>

    <DashboardApplicationSummary
      v-for="item in sortedItems"
      :key="item.id"
      :item="item"
      test-id="top-level-application-summary"
    />

    <NullState
      v-if="items.length === 0"
      :image-height="90"
      :subtitle="NULL_STATE_SUBTITLE"
      :title="NULL_STATE_TITLE"
      src="https://assets.getbridgecare.com/null-state-box.svg"
      card
    />
  </div>
</template>

<script setup>
import DashboardApplicationSummary from '@/parent/components/dashboards/DashboardApplicationSummary.vue';
import NullState from '@/shared/components/NullState.vue';

const NULL_STATE_SUBTITLE =
  `We didn't find any applications linked to the email you used to create your account. ` +
  `This doesn't mean your application doesn't exist; it could be that the email we have doesn't match an existing application. ` +
  `If you no longer see an application you saw before, you may have lost access. For help, please contact your county representative.`;
const NULL_STATE_TITLE = 'Application not found';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const $bct = inject('translator');

// * Nests managed child subsidies under the responsible family subsidy, where applicable.
const sortedItems = computed(() => {
  const items = props.items.map((item) => ({ ...item }));

  items.forEach((item) => {
    if (item.managing_family_subsidy_id) {
      const familySubsidy = items.find((i) => i.id === item.managing_family_subsidy_id);

      if (familySubsidy) {
        familySubsidy.managedSubsidies = familySubsidy.managedSubsidies ?? [];
        familySubsidy.managedSubsidies.push(item);
      }
    }
  });

  const finalItems = items.filter((item) => !item.managing_family_subsidy_id);

  return finalItems;
});
</script>
